import {
  ADD_Employee,
  GET_Employee,
  UPDATE_Employee,
  DELETE_Employee,
} from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateEmployeeAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/Employee`, data);
    dispatch({
      type: ADD_Employee,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_Employee,
      payload: "Error" + e,
    });
  }
};
export const GetAllEmployeeAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Employee?${quary}`);
    dispatch({
      type: GET_Employee,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_Employee,
      payload: "Error" + e,
    });
  }
};
export const UpdateEmployeeAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Employee`, body);
    dispatch({
      type: UPDATE_Employee,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_Employee,
      payload: "Error" + e,
    });
  }
};

export const DeleteEmployeeAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Employee?id=${Id}`);
    dispatch({
      type: DELETE_Employee,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_Employee,
      payload: "Error" + e,
    });
  }
};
